$(document).ready(function () {
    const counter = $(".counter");
    const oldDateInteger = 1700730836602;
    const currentDateInteger = Date.now();
    const dayCount = Math.floor((currentDateInteger - oldDateInteger) / 1000 / 3600 / 24);

    if (counter.length) {
        const oldCustomerCount = parseInt(counter.text().replace(/,/g, ""), 10); // Remove commas if present and parse to integer
        let customerCount;

        if (dayCount >= 1) {
            customerCount = oldCustomerCount + Math.floor(197 * dayCount);
        } else {
            customerCount = oldCustomerCount;
        }

        console.log(oldCustomerCount, ' test ', dayCount, ' test ', oldDateInteger);
        counter.text(customerCount.toLocaleString()); // Format with commas
    }
});
